module.exports = __webpack_public_path__ + "img/APP@2x.a13ee5a1.png";